import React from 'react';

const DashboardStatCard = ({ label, value, sub, accent, trend }) => (
  <div className={`border p-3 bg-[rgba(0,0,0,0.12)] flex flex-col gap-1 ${accent ? 'border-[#d8ceb3]' : 'border-[#658d71]'}`}>
    <span className="text-[9px] uppercase tracking-widest text-[#658d71] font-bold">{label}</span>
    <span className={`text-xl font-black tabular-nums ${accent ? 'text-[#d8ceb3]' : 'text-white'}`}>{value ?? '--'}</span>
    {sub && <span className="text-[9px] text-[#a9c9b1] font-bold">{sub}</span>}
    {trend != null && (
      <span className={`text-[9px] font-black uppercase tracking-widest ${trend >= 0 ? 'text-[#a9c9b1]' : 'text-[#c4333e]'}`}>
        {trend >= 0 ? '▲' : '▼'} {Math.abs(trend)}
      </span>
    )}
  </div>
);

export default DashboardStatCard;